import { render, staticRenderFns } from "./ChouqianHooks.vue?vue&type=template&id=077d4ccc&"
import script from "./ChouqianHooks.vue?vue&type=script&lang=js&"
export * from "./ChouqianHooks.vue?vue&type=script&lang=js&"
import style0 from "./ChouqianHooks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports